import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAutoCompleteCheckControlled from '@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled';
import { isNullUndefined } from '@/main/services/utils';
import { getManufacturers, resetReducerManufacturers, useManufacturerReducer } from '@/main/store/vehicle/manufacturer';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeMakeProps extends GeneralVariableType { }
function VariableTypeMake({
  filter
}: IVariableTypeMakeProps) {
  const dispatch = useDispatch();
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const { isolated: manufacturerReducer } = useManufacturerReducer(keyReducer);
  const {
    control,
  } = useFormContext();

  useEffect(() => {
    if (isNullUndefined(watcherCountry)) return;

    dispatch(getManufacturers({ guidCountry: String(watcherCountry.key) }, keyReducer));

    return () => {
      dispatch(resetReducerManufacturers(keyReducer));
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledMake = isNullUndefined(manufacturerReducer.data) || manufacturerReducer.data.length === 1
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputAutoCompleteCheckControlled
        name={`filtersDinamics.${indexField}.value`}
        disableSelectAll
        control={control}
        options={manufacturerReducer.data || []}
        label={filter.responseServer.filterName}
        disabled={disabledMake}
        isLoading={manufacturerReducer.isLoading}
        controllerProps={{ rules: { required: filter.responseServer.mandatory } }}
        customInputProps={{ required: filter.responseServer.mandatory, id: idScreen('select-make') }}
        onChangeCustom={(value, optionChanged, reason) => { }}
      />
    </>
  )
}

export default VariableTypeMake